import React, { useEffect, useState } from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, CircularProgress } from '@mui/material';
import ProjectSchedule from '../../components/ProjectSchedule'; // Ajusta la ruta a donde guardaste el componente
import { Project } from '../../types/projectTypes';
import { getActiveProjects } from '../../api/projectApi';

const ProjectSchedulePage: React.FC = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [selectedProjectId, setSelectedProjectId] = useState<number | ''>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await getActiveProjects();
        setProjects(response.data || response); // Ajusta según la estructura de tu API
      } catch (error) {
        console.error("Error al cargar los proyectos:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const handleProjectChange = (event: SelectChangeEvent<number>) => {
    setSelectedProjectId(Number(event.target.value));
  };

  if (loading) return <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box>;

  return (
    <Box sx={{ p: 3, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h4" color="black" gutterBottom>
        Cronograma de Planificación
      </Typography>

      <Box sx={{ mb: 3, width: 300 }}>
        <FormControl fullWidth>
          <InputLabel id="project-select-label">Seleccionar Proyecto</InputLabel>
          <Select
            labelId="project-select-label"
            value={selectedProjectId}
            label="Seleccionar Proyecto"
            onChange={handleProjectChange}
          >
            {projects.map((project) => (
              <MenuItem key={project.id} value={project.id}>
                {project.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* Solo mostramos la grilla si hay un proyecto seleccionado */}
      {selectedProjectId !== '' ? (
        <Box sx={{ flexGrow: 1 }}>
          <ProjectSchedule projectId={selectedProjectId as number} />
        </Box>
      ) : (
        <Typography variant="body1" color="textSecondary">
          Selecciona un proyecto para visualizar su cronograma.
        </Typography>
      )}
    </Box>
  );
};

export default ProjectSchedulePage;